"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var ConversationService = /** @class */ (function () {
    function ConversationService(conversationClient) {
        this.conversationClient = conversationClient;
    }
    ConversationService.prototype.sendStartingConversationMessage = function (senderId, receiverId, nick, content, advertisementId, images, subregionName, regionShortName, startDate) {
        var _this = this;
        if (subregionName === void 0) { subregionName = null; }
        if (regionShortName === void 0) { regionShortName = null; }
        if (startDate === void 0) { startDate = null; }
        return new Promise(function (success, reject) {
            var messageRequest = new WickedApiClient_1.StartConversationMessageSubmitRequestModel();
            messageRequest.content = content;
            messageRequest.receiverId = receiverId;
            messageRequest.senderId = senderId;
            messageRequest.senderNick = nick;
            messageRequest.advertisementId = advertisementId;
            messageRequest.images = images;
            if (subregionName != null || startDate != null) {
                messageRequest.additionalInformations = new WickedApiClient_1.ConversationAdditionalInformations();
                if (subregionName != null) {
                    messageRequest.additionalInformations.subregionName = subregionName;
                }
                if (regionShortName != null) {
                    messageRequest.additionalInformations.regionShortName = regionShortName;
                }
                if (startDate != null) {
                    messageRequest.additionalInformations.advertisementData = startDate;
                }
            }
            _this.conversationClient.sendStartingMessage(messageRequest).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else {
                    success(result.conversationKey);
                }
            });
        });
    };
    ConversationService.prototype.sendMessageToExistingConversation = function (senderId, content, conversationId, images) {
        var _this = this;
        return new Promise(function (success, reject) {
            var messageRequest = new WickedApiClient_1.ConversationMessageSubmitRequestModel();
            messageRequest.content = content;
            messageRequest.senderId = senderId;
            messageRequest.conversationId = conversationId;
            messageRequest.images = images;
            _this.conversationClient.sendConversationMessage(messageRequest).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else {
                    success(result.conversationKey);
                }
            });
        });
    };
    ConversationService.prototype.deleteConversation = function (conversationId, arrayIndex) {
        var _this = this;
        if (arrayIndex === void 0) { arrayIndex = null; }
        return new Promise(function (rs, rj) {
            var deleteRequestModel = new WickedApiClient_1.ConversationDeleteRequestModel();
            deleteRequestModel.init({
                conversationId: conversationId
            });
            _this.conversationClient.deleteConversation(deleteRequestModel).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result.error);
                }
                if (_this.lastConversations.length > 0 && !isNaN(arrayIndex)) {
                    _this.lastConversations.splice(arrayIndex, 1);
                }
                rs(result);
            });
        });
    };
    ConversationService.prototype.getConversation = function (conversationId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.conversationClient.getConversation(conversationId).subscribe(function (response) {
                if (response.error) {
                    reject(response.error);
                }
                else {
                    resolve(response.conversation);
                }
            });
        });
    };
    ConversationService.prototype.getConversations = function (perPage, page) {
        var _this = this;
        if (perPage === void 0) { perPage = 0; }
        if (page === void 0) { page = 0; }
        return new Promise(function (resolve, reject) {
            _this.conversationClient.getConversations(new WickedApiClient_1.UserConversationsRequestModel(), perPage, page).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else {
                    if (page == 0) {
                        _this.lastConversations = result.conversations;
                    }
                    resolve(result);
                }
            });
        });
    };
    ConversationService.prototype.getConversationsCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.conversationClient.getConversationsCount(new WickedApiClient_1.UserConversationsRequestModel()).subscribe(function (result) {
                resolve(result);
            });
        });
    };
    ConversationService.prototype.getLastConversations = function () {
        return this.lastConversations;
    };
    ConversationService.prototype.getUnreadedMessageCount = function () {
        return this.conversationClient.getUnreadedMessages().toPromise();
    };
    ConversationService.prototype.setReadedMessages = function (conversationId, messages) {
        if (!conversationId || messages == null || messages.length == 0) {
            return;
        }
        return this.conversationClient.setReadedMessages(messages, conversationId).toPromise();
    };
    ConversationService.prototype.getActiveConversationId = function (advertisementId) {
        return this.conversationClient.getActiveConversationId(advertisementId);
    };
    ConversationService.prototype.restoreConversationsHasMessages = function () {
        var _this = this;
        return new Promise(function (success, reject) {
            _this.conversationClient.restoreConvHasMessages().subscribe(function (result) {
                console.log(result);
            });
        });
    };
    ConversationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConversationService_Factory() { return new ConversationService(i0.ɵɵinject(i1.ConversationClient)); }, token: ConversationService, providedIn: "root" });
    return ConversationService;
}());
exports.ConversationService = ConversationService;
